import React, { useEffect, useState } from "react";
import { AuthNavbar } from "../../components/auth/AuthNavbar";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { CustomButton } from "../../components/button/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { userCheckoutThunk as onUserCheckoutThunk ,getPaymentPlanThunk as onGetPaymentPlans} from "../../slices/users/thunk";
import { resetFlags } from "../../slices/users/reducer";
import master_logo from "../../assets/mastercard-logo.png";
import visa_logo from "../../assets/visa-logo.png";

import { createSelector } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";



import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import axios from "axios";
import { Spinner } from "../../components/spinner/Spinner";

export const Checkout = () => {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [planInfo, setPlanInfo] = useState(null);
  const { userId, planId,role } = useParams();
    const [ isSpinner, setIsSpinner ] = useState(false);

   

  const stripe = useStripe();
  const elements = useElements();

  const selectUserState = (state) => state.user;
  const userProperties = createSelector(selectUserState, (user) => ({

    isSuccess: user.isSuccess,
    isLoading: user.isLoading,
    userId: user.userId,
    paymentPlans: user.paymentPlans,

  }));

    useEffect(() => {
    dispatch(resetFlags());
  }, [dispatch])

  const { isLoading, isSuccess, paymentPlans } = useSelector(userProperties);

  useEffect(() => {
    dispatch(onGetPaymentPlans({'planId':planId,'role':role}));
  }, [dispatch]);

  useEffect(() => {
    if (paymentPlans && paymentPlans.length > 0) {
      const selectedPlan = paymentPlans.find(
        (plan) => Number(plan.planId) === Number(planId)
      );
      setPlanInfo(selectedPlan || null);
    }
  }, [paymentPlans, planId]);

  useEffect(() => {
    if (isSuccess) {
      toast.success("User subscribed successfully!");
      navigate("/user");
    }
  }, [isSuccess, navigate]);

  const handleFormSubmit = async () => {

    if (!stripe || !elements) return;



    const cardElement = elements.getElement(CardNumberElement);

     
     setIsSpinner(true)
    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name: "Test User",
      },
    });

    if (error) {
           setIsSpinner(false)
      toast.error(error.message);
      return;
    }



const res = await axios.post(
  `${process.env.REACT_APP_API_URL}/create-stripe-payment-intent`,
  {
    amount: planInfo.price * 100,
    user_id: userId,
    plan_id: planId,
    payment_method: paymentMethod.id,
  }
);


    const  clientSecret  = res.data.data;


    // Confirm card payment
    const { paymentIntent, error: confirmError } =
      await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethod.id,
      });

    if (confirmError) {
      toast.error(confirmError.message);
      return;
    }

    if (paymentIntent.status === "succeeded") {
      dispatch(
        onUserCheckoutThunk({
          user_id: userId,
          plan_id: planId,
          amount: planInfo.price,
          stripe_payment_id: paymentIntent.id,
        })
      );
    }



  };


       useEffect(() => {
    if (isLoading) {
      setIsSpinner(isLoading)
    } else {
    setIsSpinner(isLoading)
    
    }
  }, [isLoading]);

  const userSubscribe=()=>{
          dispatch(
        onUserCheckoutThunk({
          user_id: userId,
          plan_id: planId,
          amount: planInfo.price,
          stripe_payment_id:null,
        })
      );

  }

  return (
    <div className="w-full min-h-screen bg-[#F7F7F7]">
      <AuthNavbar title="Checkout" />
      <div className="pt-20 sm:pt-28  px-4 sm:px-10">
        <div className="w-[50px] h-[50px] bg-transparent rounded-[10px] border border-border_color flex items-center justify-center cursor-pointer">
          <button onClick={() => navigate("/pricing")}>
            <BiArrowBack className="text-4xl" />
          </button>
        </div>
      </div>
      <div className="w-full  flex items-center justify-center sm:px-5 ">
        <div className="w-full p-4">
          <div className="flex mx-auto max-w-[1600px] justify-center items-center bg-white rounded-[20px] shadow-md w-full p-4 sm:py-[42px] sm:px-[56px] mb-10">
            <div className="w-full flex flex-col lg:flex-row justify-center  lg:items-start items-center  gap-8">
           
              {planInfo?.price > 0 && (
              <div className="w-full lg:w-[60%] border border-border_color rounded-[20px] flex flex-col p-2 sm:p-7 items-center">
                <div className="w-full flex items-center justify-between mb-7">
                  <div className="text-start text-[#494034] text-sm lg:text-xl xl:text-2xl font-bold font-grotesk w-full">Add Card to Pay</div>
                  <div className="w-full flex items-center justify-end gap-1 sm:gap-3 mt-1">
                     <div className="w-12 h-9 sm:w-[70px] sm:h-12 border border-border_color rounded-lg p-2">
                      <img src={visa_logo} alt="Visa" className="w-full h-full object-contain" />
                     </div>
                     <div className="w-12 h-9 sm:w-[70px] sm:h-12 border border-border_color rounded-lg p-2">
                      <img src={master_logo} alt="Mastercard" className="w-full h-full object-contain" />
                     </div>
                  </div>
                </div>
                <form className="w-full">
                  <div className="mb-4">
                    <CardNumberElement className="p-3 border rounded-xl" />
                  </div>
                  <div className="flex flex-col md:flex-row gap-2">
                    <div className="mb-4 w-full">
                      <CardExpiryElement className="p-3 border rounded-xl" />
                    </div>
                    <div className="mb-4 w-full">
                      <CardCvcElement className="p-3 border rounded-xl" />
                    </div>
                  </div>
                </form>
              </div>

              )}
            
              <div className="w-full lg:w-[40%]  border border-border_color rounded-[20px] flex flex-col p-2 sm:p-7 items-center">
                <h2 className="text-start text-secondary text-[26px] font-bold font-grotesk mb-4 w-full ">
                  Summary
                </h2>

                <div className="w-full border border-border_color rounded-2xl p-3 sm:p-6 flex justify-between bg-white shadow-boxShadow">
                  <div className="w-full flex flex-col gap-7">
                    <h2 className="text-secondary text-[22px] font-bold font-grotesk">
                      {planInfo?.title}
                    </h2>

                    <div className="flex items-end gap-2">
                      <span className="text-[40px] leading-none text-primary font-bold font-grotesk">
                        ${planInfo?.price}
                      </span>
                      <span className="text-[16px] font-bold font-grotesk text-[#797878] mb-1">
                        per month
                      </span>
                    </div>

                    <div className="flex flex-col gap-2">
                      {planInfo?.plannedServices?.map((service, idx) => (
                        <p
                          key={idx}
                          className="flex items-center text-black text-lg font-medium font-grotesk"
                        >
                          <span className="w-5 h-5 mr-2 flex items-center justify-center bg-white border rounded-full flex-shrink-0">
                            {service.enable == 1 ? (
                              <svg
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-3 h-3 text-green-600"
                                viewBox="0 0 24 24"
                              >
                                <path d="M20 6L9 17l-5-5" />
                              </svg>
                            ) : (
                              <svg
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-3 h-3 text-red-600"
                                viewBox="0 0 24 24"
                              >
                                <path d="M18 6L6 18M6 6l12 12" />
                              </svg>
                            )}
                          </span>
                          {service.service}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="w-full border-t border-border_color mt-8 flex flex-col gap-2 py-10 px-2 sm:px-3">
                  <div className="flex items-center justify-between ">
                    <span className="font-bold text-sm xs:text-lg font-grotesk text-[#1C1E21">Plan Name</span>
                    <span className="font-bold underline tracking-wide text-sm xs:text-lg font-grotesk text-primary">
                      {planInfo?.title}
                    </span>
                  </div>
                  <div className="flex items-center justify-between ">
                    <span className="font-bold text-sm xs:text-lg font-grotesk text-[#1C1E21">Price</span>
                    <span className="font-medium text-sm xs:text-lg font-grotesk text-[#1C1E21]">${planInfo?.price}/per month</span>
                  </div>
                  <div className="flex items-center justify-between ">
                    <span className="font-bold text-sm xs:text-lg font-grotesk text-[#1C1E21">Total:</span>
                    <span className="font-medium text-sm xs:text-lg font-grotesk text-[#1C1E21]">${planInfo?.price}</span>
                  </div>
                  <p className='font-grotesk text-xs xs:text-[16px] font-medium leading-normal text-[#1C1E21]'>By purchasing this product you are accepting the <span className='text-primary font-bold'>Raginald <span className='underline'>Terms & Conditions</span></span></p>

                  <div className="w-full mt-8">
                

          <CustomButton  onClick={planInfo?.price > 0 ? handleFormSubmit : userSubscribe} text={isSpinner ? <Spinner /> : "Checkout"} 
/>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
